import {
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Box,
  Flex,
  Text,
} from "@chakra-ui/react";

import { AiOutlineMore } from "react-icons/ai";

import { getCommunityIcon, SUB_HEADER_OPTIONS } from "@constants/common";
import { SubHeaderType } from "@constants/types";
import BaseImage from "@components/BaseImage";
import { trackEvent } from "utils";
import { CLICK_SUB_HEADER } from "@constants/analytics";
import UTMLink from "@components/UTMLink";

interface HeaderProps {
  shouldDisplayMenu: boolean;
  onChangeDisplayMenu(isVisible: boolean): void;
}

const SubHeader = ({ shouldDisplayMenu, onChangeDisplayMenu }: HeaderProps) => {
  const getHeaderItem = (item: SubHeaderType) => {
    return (
      <Flex justifyContent="space-between" alignItems="center" mt="1.5rem">
        <Flex alignItems="center">
          <Box
            display="flex"
            w={{ base: "32px", lg: "48px" }}
            h={{ base: "32px", lg: "48px" }}
            borderRadius="50%"
            bg="backgroundCanvas"
            alignItems="center"
            justifyContent="center"
          >
            {item.key && getCommunityIcon(item.key) ? (
              <BaseImage
                width={24}
                height={24}
                src={getCommunityIcon(item.key) || ""}
                alt={item.key}
              />
            ) : null}
          </Box>

          <Text
            fontWeight="600"
            fontSize="16px"
            lineHeight="24px"
            ml="1rem"
            color="textPrimary"
          >
            {item.name}
          </Text>
        </Flex>

        <BaseImage
          width={24}
          height={24}
          src="/assets/chervon-right.svg"
          alt={item.key}
        />
      </Flex>
    );
  };

  const getSubHeader = () =>
    SUB_HEADER_OPTIONS?.map((item, index) => (
      <UTMLink
        cursor="pointer"
        href={item.link}
        target="_blank"
        rel="nofollow"
        key={index}
        onClick={() => {
          trackEvent(CLICK_SUB_HEADER, {
            type: item.key,
          });
        }}
      >
        {getHeaderItem(item)}
      </UTMLink>
    ));

  return (
    <>
      <Menu>
        <MenuButton
          as={IconButton}
          aria-label="Options"
          fontSize="24px"
          icon={<AiOutlineMore height="24px" width="24px" />}
          variant="icon"
          ml={{ base: "4px", lg: "6px" }}
          mr={{ base: 0, xl: "2.5rem" }}
          bg="backgroundCard"
          display={{ base: "none", lg: "inline-flex" }}
          borderRadius="0.5rem"
          h="56px"
          w="48px"
        />
        <MenuList
          borderRadius="1rem"
          border="1px solid"
          borderColor="textPrimary"
          bg="backgroundCard"
          p="0rem 1.5rem 2.5rem"
          display="flex"
          flexDirection="column"
          boxShadow="4px 24px 40px rgba(0, 0, 0, 0.12)"
          width="280px"
          maxW="100%"
          zIndex="4"
        >
          {getSubHeader()}
        </MenuList>
      </Menu>
      <Drawer
        isOpen={shouldDisplayMenu}
        onClose={() => onChangeDisplayMenu(false)}
        placement="bottom"
      >
        <DrawerOverlay bg="modalOverlay" />
        <DrawerContent
          bg="backgroundCard"
          borderTopRadius="2rem"
          p="2.5rem 1rem"
        >
          <DrawerBody p="0">{getSubHeader()}</DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default SubHeader;
